export default __webpack_public_path__ + "static/media/1881.5b1358e1.png";